import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import NavigationHelper from 'layers/navigation/navigationHelper'
import { navigationEvent } from 'layers/navigation/store/operations'
import K8ProgramPrimaryCTAComponent from './component'

const mapDispatchToProps = {
  navigationEvent,
}

const K8ProgramPrimaryCTAContainer = ({
  content,
  useCase,
  route,
  navigationEvent,
  contentfulCourses,
}) => {
  const { header, bodyCopy, buttonLabel, route: contentRoute, icon } =
    content || {}

  const handleClick = () => {
    // Use the route from content object first, then fall back to the route prop
    const targetRoute = contentRoute || route
    if (targetRoute) {
      navigationEvent(targetRoute, NavigationHelper.types.PUSH)
    }
  }

  return (
    <K8ProgramPrimaryCTAComponent
      bodyCopy={bodyCopy}
      buttonLabel={buttonLabel}
      contentfulCourses={contentfulCourses}
      header={header}
      iconUrl={icon?.url}
      onClick={handleClick}
      useCase={useCase}
    />
  )
}

K8ProgramPrimaryCTAContainer.propTypes = {
  content: PropTypes.shape({
    header: PropTypes.string,
    buttonLabel: PropTypes.string,
    bodyCopy: PropTypes.string,
    route: PropTypes.string,
  }),
  contentfulCourses: PropTypes.array,
  navigationEvent: PropTypes.func.isRequired,
  route: PropTypes.string,
  useCase: PropTypes.string,
}

export default connect(null, mapDispatchToProps)(K8ProgramPrimaryCTAContainer)
